<template>
    <page>
        <module title="系统配置">
            <c-form ref="form">
				<c-form title="平台基本配置">
					<c-form-item type="radio" label="商品货号必填" :options="switchOptions"  name="PRODUCT_NUMBER_REQUIRED" word="注:必填开启后会校验货号全局唯一"></c-form-item>
					<c-form-item type="radio" label="商品SKU编码规则" :options="skuCreateTypeOptions"  name="PRODUCT_SKU_CODE_AUTOCREATE_TYPE" ></c-form-item>
					<c-form-item type="radio" label="商品分类层级" :options="productTypeLevelOptions"  name="SYS_PRODUCT_TYPE_LEVEL_COUNT" ></c-form-item>
					<c-form-item type="radio" label="商品分类关联类型" :options="productTypeLinkType"  name="SYS_PRODUCT_TYPE_LINK_TYPE" ></c-form-item>
					<c-form-item type="radio" label="价格低物流公司优先展示" :options="switchOptions"  name="SYS_LOGISTICS_COMPANY_PRICE_PRIORITY_ENABLED" word="下单时，物流费用低物流公司的优先展示"></c-form-item>
					<!-- <c-form-item type="input" label="七鱼客服组ID" name="QIYUKF_USER_ID"   ></c-form-item> -->
					<!-- <c-form-item type="radio" label="登录验证码"  name="OMS_LOGIN_VERIFY_SWITCH"  :options="switchOptions" ></c-form-item> -->
					<!-- <c-form-item type="input" label="平台发货地址" name="SHIPPING_ADDRESS"></c-form-item> -->
				</c-form>
				<c-form title="平台PC站">
					<c-form-item type="radio" label="是否开通PC站"   :options="switchOptions"  name="PC_ENABLED" ></c-form-item>
					<c-form-item type="input" label="PC商城预览地址" name="PC_MALL_URL"></c-form-item>
					<c-form-item type="image" label="小程序二维码" name="MINI_CODE_IMG" file-word="PC砍价时使用,【建议尺寸：480X480px,支持jpg、png，图片大小1M以内】" ></c-form-item>
				</c-form>
				<c-form title="功能控制">
					<c-form-item type="radio" label="订单审核"   :options="switchOptions"  name="ORDER_CHECK_ENABLED" ></c-form-item>
					<c-form-item type="radio" label="售后审批"   :options="switchOptions"  name="RETURN_ORDER_CHECK_ENABLED" ></c-form-item>
					<c-form-item type="radio" label="订单开票"   :options="switchOptions"  name="ORDER_INVOICE_ENABLED" ></c-form-item>
				<!-- <c-form-item type="radio" label="会员是否允许升级"   :options="switchOptions"  name="USER_LEVEL" ></c-form-item> -->
					<c-form-item type="radio" label="代发地址"   :options="switchOptions"  name="AGENT_DELIVERY_ENABLED" ></c-form-item>
					<c-form-item type="radio" label="是否开通分销功能"  :options="switchOptions"  name="SHARE_ENABLE" ></c-form-item>
				</c-form>
				<c-form title="支付方式">
					<c-form-item type="radio" label="余额支付"  :options="switchOptions"  name="ACCOUNT_BALANCE_ENABLED"></c-form-item>
					<c-form-item type="radio" label="银行转账支付"   :options="switchOptions"  name="CASH_PAY" ></c-form-item>
                    <c-form-item type="radio" label="授信支付"   :options="switchOptions"  name="CREDIT_PAY" ></c-form-item>
                    <c-form-item type="radio" label="微信支付"   :options="switchOptions"  name="WECHAT_PAY" v-model="WECHAT_PAY"></c-form-item>
                    <c-form-item type="radio" label="【代理商】微信支付"  :options="switchOptions"  name="AGENCY_WECHAT_PAY" v-if="WECHAT_PAY == 'ON'"></c-form-item>
                    <c-form-item type="radio" label="支付宝支付"   :options="switchOptions"  name="ALI_PAY" ></c-form-item>
				</c-form>
				<c-form title="订单营销">
					<c-form-item type="radio" label="订单评价"   :options="switchOptions"  name="ORDER_EVALUATE" ></c-form-item>
					<c-form-item type="radio" label="积分体系"   :options="switchOptions"  name="POINTS_SYSTEM" ></c-form-item>
					<c-form-item type="radio" label="商品定制"   :options="switchOptions"  name="PRODUCT_CUSTOM" ></c-form-item>
					<c-form-item type="radio" label="预定活动"   :options="switchOptions"  name="PRESELL_ENABLED" ></c-form-item>
					<c-form-item type="radio" label="砍价活动"   :options="switchOptions"  name="BARGAIN_ENABLED" ></c-form-item>
				</c-form>
				<c-form title="经销商">
					<c-form-item type="radio" label="经销商店铺" v-model="OMS_SELLER_SHOP_ENABLED"  :options="switchOptions"  name="OMS_SELLER_SHOP_ENABLED" ></c-form-item>
					<c-form-item v-show="OMS_SELLER_SHOP_ENABLED == 'ON'" type="input" label="系统名称" name="SELLER_SYSTEM_NAME"></c-form-item>
					<c-form-item v-show="OMS_SELLER_SHOP_ENABLED == 'ON'" type="image" label="登录页Logo" name="SELLER_LOGIN_LOGO" file-word="【建议尺寸：高度140px,宽度600px以内,支持jpg、png，图片大小1M以内】"></c-form-item>
					<c-form-item v-show="OMS_SELLER_SHOP_ENABLED == 'ON'" type="image" label="内页Logo" name="SELLER_LOGO" file-word="【建议尺寸：400X88px,支持jpg、png，图片大小1M以内，最好是透明图】"></c-form-item>
					<c-form-item v-show="OMS_SELLER_SHOP_ENABLED == 'ON'" type="image" label="ICON图标" name="SELLER_FAVICON" file-word="【建议尺寸：32X32px,支持jpg、png，图片大小1M以内】"></c-form-item>
					<c-form-item v-show="OMS_SELLER_SHOP_ENABLED == 'ON'" type="input" label="版权信息" name="SELLER_COPYRIGHT" ></c-form-item>
				</c-form>
				<c-form title="系统结构">
					<c-form-item type="radio" label="销售模式" :options="saleMode"  name="SALE_MODE" ></c-form-item>
					<c-form-item type="radio" label="商城模式" v-model="PT_MODE" :options="ptMode"  name="PT_MODE" ></c-form-item>
					<c-form-item v-show="PT_MODE == 2" type="radio" label="展示运营模式" :options="switchOptions"  name="OPERATION_MODE_ENABLED" word="注:商城模式为【多商户运营】时有效，订单/商品等处展示"></c-form-item>
					<c-form-item v-show="PT_MODE == 2" type="radio" label="展示商家角色名称" :options="switchOptions"  name="STATIONED_AUTHNAME_ENABLED" word="注:商城模式为【多商户运营】时有效，订单/商品等处展示"></c-form-item>
					<c-form-item v-show="PT_MODE == 2" type="radio" label="商家修改品牌介绍" :options="switchOptions"  name="STATION_SHOP_CONTENT_ENABLED" word="注:商城模式为【多商户运营】时有效"></c-form-item>
				</c-form>
				<c-form title="三方对接">
					<c-form-item type="radio" label="三方对接"  v-model="ORDER_PUSH_ENABLED" :options="switchOptions"  name="ORDER_PUSH_ENABLED" ></c-form-item>
					<c-form-item v-show="ORDER_PUSH_ENABLED == 'ON'" type="input" label="聚水潭接口地址" name="JUSHUITAN_API_URL" word="注:开启三方对接时有效,结尾请保留“/”"></c-form-item>
					<c-form-item v-show="ORDER_PUSH_ENABLED == 'ON'" type="input" label="聚水潭APP Key" name="JUSHUITAN_APP_KEY" word="注:开启三方对接时有效"></c-form-item>
					<c-form-item v-show="ORDER_PUSH_ENABLED == 'ON'" type="input" label="聚水潭APP Secret" name="JUSHUITAN_APP_SECRET" word="注:开启三方对接时有效"></c-form-item>
					<c-form-item v-show="ORDER_PUSH_ENABLED == 'ON'" type="input" label="聚水潭accessToken" name="JUSHUITAN_REFRESH_TOKEN" word="注:开启三方对接时有效"></c-form-item>
					<c-form-item v-show="ORDER_PUSH_ENABLED == 'ON'" type="input" label="聚水潭refreshToken" name="JUSHUITAN_ACCESS_TOKEN" word="注:开启三方对接时有效"></c-form-item>
					<c-form-item v-show="ORDER_PUSH_ENABLED == 'ON'" type="input" label="token过期时间" name="JUSHUITAN_EXPIRES_DATE" word="注:开启三方对接时有效"></c-form-item>
					<c-form-item v-show="ORDER_PUSH_ENABLED == 'ON'" type="input" label="自营店铺ID" :limit="[1,99999999999]" name="JUSHUITAN_SHOP_ID" word="注:开启三方对接时有效"></c-form-item>
				</c-form>
				<c-form title="其他">
					<c-form-item type="radio" label="技术支持显示" :options="switchOptions"  name="SYS_TECHNICAL_SUPPORT_ENABLED" ></c-form-item>
				</c-form>
                
                <!--
                <c-form-item type="input" label="客服电话" name="CUSTOMER_SERVICE_PHONE"   ></c-form-item>
                <c-form-item type="input" label="联系邮箱" name="CUSTOMER_SERVICE_EMAIL"   ></c-form-item>
                -->
                
            </c-form>

            <template slot="button">
                <c-button size="m" power="b_platform_config_save" @click="save()">保存</c-button>
            </template>
        </module>

    </page>
</template>

<script>

    export default {
        name: 'm_platform_config',

        components: {
        },

        props: {
            id: String
        },

        data() {
            return {
				OMS_SELLER_SHOP_ENABLED: 'OFF',
                WECHAT_PAY: 'OFF',
				ORDER_PUSH_ENABLED: 'OFF',
				PT_MODE: 1,
                fromData:{
                    qiyukf_user_id:{id:'4',value:''},
                    oms_login_verify_switch:{id:'1',value:'ON'},
                    withdrawal_rate:{id:'2',value:''},
                    a_single_withdrawal_limit:{id:'3',value:''},
                    order_points_enabled:{id:'5',value:'ON'},
                    order_points_money_unit:{id:'6',value:''},
                    order_points_expired_period:{id:'7',value:''},
                    return_order_check_enabled:{id:'20',value:'ON'},
                },
                switchOptions: [{
                    name: '开启',
                    value: 'ON'
                }, {
                    name: '关闭',
                    value: 'OFF'
                }],
				ptMode:[{
                    name: '单平台运营',
                    value: '1'
                }, {
                    name: '多商户运营',
                    value: '2'
                }],
				saleMode:[{
                    name: '零售',
                    value: '1'
                }, {
                    name: '批发',
                    value: '2'
                }],
	            occupancyTypeOptions:[{
                    name: '下单后占用',
                    value: '1'
                }, {
                    name: '支付后占用',
                    value: '2'
                }],
                skuCreateTypeOptions: [{
                    name: '货号+3位序号',
                    value: 'productnumberseq'
                },{
                    name: '商品ID+3位序号',
                    value: 'productidseq'
                }],
				productTypeLevelOptions: [{
                    name: '一级',
                    value: 1
                }, {
                    name: '二级',
                    value: 2
                }, {
                    name: '三级',
                    value: 3
                }],
				productTypeLinkType: [{
                    name: '关联跳转链接',
                    value: 1
                }, {
                    name: '关联商品',
                    value: 2
                }]
            }
        },

        watch: {

        },

        mounted() {
            this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: '/platform_config/list',
                    data: {
                        config_group: ""
                    },
                    loading: true,
                    success: data => {
                        let json = {};
                        data.forEach(function (item,i){
                            var value = item.config_item_value;
                            if (item.config_item_code == 'WITHDRAWAL_RATE'){
                              value = value*100;
                            }
                            json[item.config_item_code] = value;
                        });
                        this.$refs.form.set(json);

                    }
                });
            },


            save() {
                this.$refs.form.submit({
                    url: '/platform_config/edit',
                    dataFormatter: data => {
                        let arr = [];
                        for (let key in data) {
                            var value = data[key];
                            if (key == 'WITHDRAWAL_RATE'){
                              value = value/100;
                            }
                            arr.push({
                                config_item_code: key,
                                config_item_value: value || ''
                            });
                        }
                        return {
                            platform_config_list: arr
                        };
                    },
                    success: () => {
						this.$store.dispatch('getSystemConfig');
                        this.$message({
                            text: '操作成功'
                        });

                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>

</style>